import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '../Box/Box';
import * as styles from './ContentBlock.css';
export const ContentBlock = ({ width = 'page', children, paddingX = 'm', className, ...allBoxProps }) => {
    return (_jsx(Box, { className: [styles.root, styles.width[width], className], paddingX: paddingX, ...allBoxProps, children: children }));
};
